/**
 *
 * ラベル名はCSSで指定しています。
 *
 */
import { useState } from "react";
import { Radio, RadioGroup } from "@fluentui/react-components";
import * as CONST from "../../utils/constant";

import styles from "./ToggleModelButton.module.css";

interface Props {
    environment: any;
    aiModelRef: React.MutableRefObject<string>;
    onModelChange: (model: string) => void;
    disabled?: boolean;
}

export const ToggleModelButton = ({ environment, aiModelRef, onModelChange, disabled }: Props) => {
    const enabledGPT4o = environment.useModelGpt4o || false;

    const [value, setValue] = useState(CONST.AI_MODEL_VALUE.GPTMODEL_DEFAULT);

    const handleChange = (e: any, data: any) => {
        setValue(data.value);
        aiModelRef.current = data.value || CONST.AI_MODEL_VALUE.GPTMODEL_DEFAULT;
        onModelChange(data.value);
    };

    return (
        <div
        className={styles.modelChange}
        style={{
            '--content-model-default': `"${CONST.AI_MODEL_DISP_NAME.GPTMODEL_DISP_DEFAULT}"`,
            '--content-model-change': `"${CONST.AI_MODEL_DISP_NAME.GPTMODEL_DISP_CHANGE}"`,
        } as React.CSSProperties}
        >
            <RadioGroup className={styles.modelGroup} value={value} layout="horizontal" onChange={handleChange} aria-labelledby="">
                {enabledGPT4o ? (
                    <>
                        <Radio className={styles['model-default']} value={CONST.AI_MODEL_VALUE.GPTMODEL_DEFAULT} label="" disabled={disabled} />
                        <Radio className={styles['model-change']} value={CONST.AI_MODEL_VALUE.GPTMODEL_CHANGE} label="" disabled={disabled} />
                    </>
                ) : (
                    <Radio className={styles['model-change']} value={CONST.AI_MODEL_VALUE.GPTMODEL_CHANGE} label="" disabled />
                )}
            </RadioGroup>
            <div className={`${styles.circleSwitch} ${value === CONST.AI_MODEL_VALUE.GPTMODEL_DEFAULT ? styles.circleLeft : styles.circleRight}`}></div>
        </div>
    );
};
